import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UserProfile {
  id: string;
  userName: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  phoneNumber?: string;
  roles?: string[];
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private userProfileSubject = new BehaviorSubject<UserProfile | null>(null);
  public userProfile$ = this.userProfileSubject.asObservable();
  private profileKey = 'user_profile';
  private baseUrl = environment.api;

  constructor(private http: HttpClient) {
    // Load profile from localStorage if available
    const storedProfile = localStorage.getItem(this.profileKey);
    if (storedProfile) {
      try {
        this.userProfileSubject.next(JSON.parse(storedProfile));
      } catch (e) {
        console.error('Error parsing stored profile:', e);
      }
    }
  }

  loadProfile(token: string): Observable<UserProfile> {
    const headers = { 'Authorization': `Bearer ${token}` };
    const url = `${this.baseUrl}/identity/Account/GetProfileInfo`;
    
    return this.http.post<UserProfile>(url, {}, { headers })
      .pipe(
        tap(profile => {
          this.setProfile(profile);
        }),
        catchError(error => {
          console.error('Error loading user profile:', error);
          return of(null as any);
        })
      );
  }

  setProfile(profile: UserProfile): void {
    this.userProfileSubject.next(profile);
    localStorage.setItem(this.profileKey, JSON.stringify(profile));
  }

  getProfile(): UserProfile | null {
    return this.userProfileSubject.value;
  }

  getUserId(): string | null {
    const profile = this.getProfile();
    return profile?.id || null;
  }

  clearProfile(): void {
    this.userProfileSubject.next(null);
    localStorage.removeItem(this.profileKey);
  }
}